import { attr, css, customElement, GenesisElement, html, observable } from '@genesislcap/web-core';

interface DonutItem {
  type: string;
  value: number;
}

@customElement({
  name: 'allocation-donut',
  template: html<AllocationDonut>`
    <rapid-g2plot-chart
      type="pie"
      :config=${(x) => x.chartConfig}
      :data=${(x) => x.donutData}
    ></rapid-g2plot-chart>
  `,
  styles: css`
    :host {
      display: block;
      height: 100%;
      width: 100%;
    }
  `,
})
export class AllocationDonut extends GenesisElement {
  @attr amount: string;

  @attr allocation: string;

  @attr filled: string;

  @observable donutData: DonutItem[];

  @observable chartConfig;

  connectedCallback() {
    super.connectedCallback();
    this.donutData = this.getData();
    this.chartConfig = {
      appendPadding: 3,
      data: this.donutData,
      angleField: 'value',
      colorField: 'type',
      radius: 1,
      innerRadius: 0.5,
      label: false,
      legend: false,
      autofit: true,
      tooltip: false,
      statistic: false,
      annotations: false,
      color: this.getColors(),
      width: '100%',
      interactions: [{ type: 'element-active' }],
    };
  }

  private getData(): DonutItem[] {
    const filled = parseInt(this.filled);
    // const allocation = parseInt(this.allocation) - filled;
    const remaining = 100 - filled;
    return [
      { type: 'filled', value: filled },
      // { type: 'allocation', value: allocation},
      { type: 'remaining', value: remaining },
    ];
  }

  private getColors(): string[] {
    const filled = parseInt(this.filled);
    let color;

    if (filled >= 75) {
      color = 'rgb(0, 255, 0)';
    } else if (filled > 25) {
      color = '#FFD500FF';
    } else {
      color = 'rgb(255,0,0)';
    }
    return [color, 'transparent'];
  }
}
